import { ContractorSearchPage } from '@features/Contractor/Search/ContractorSearchPage'
import { contractorSearchSchema } from '@services/queryOptions'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/contractor/search')({
  validateSearch: contractorSearchSchema,
  loaderDeps: ({ search }) => search,
  component: ContractorSearchPage,
  staticData: { breadcrumb: 'Entreprenør' },
})
